import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vShow as _vShow, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "bg-container" }
const _hoisted_2 = { class: "main-container" }
const _hoisted_3 = {
  key: 0,
  class: "text-sm text-gray-500"
}
const _hoisted_4 = { class: "filter-controls" }
const _hoisted_5 = { class: "filter-group" }
const _hoisted_6 = { class: "filter-group" }
const _hoisted_7 = { class: "filter-group" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "filter-group" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "filter-group" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "filter-group" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "filter-group" }
const _hoisted_19 = { class: "filter-group" }
const _hoisted_20 = { class: "filter-group" }
const _hoisted_21 = { class: "filter-group" }
const _hoisted_22 = { class: "checkbox-label" }
const _hoisted_23 = { class: "filter-group" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = { class: "filter-group" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = { class: "history-table" }
const _hoisted_28 = { class: "table-header" }
const _hoisted_29 = { class: "history-list" }
const _hoisted_30 = { class: "item-info" }
const _hoisted_31 = { class: "dish-info-column" }
const _hoisted_32 = { class: "dish-name" }
const _hoisted_33 = { class: "dish-badges" }
const _hoisted_34 = {
  key: 1,
  class: "spec-badge"
}
const _hoisted_35 = {
  key: 2,
  class: "cook-badge"
}
const _hoisted_36 = { class: "table-info" }
const _hoisted_37 = { class: "table-info" }
const _hoisted_38 = { class: "create-time" }
const _hoisted_39 = { class: "serve-time" }
const _hoisted_40 = { class: "quantity-info" }
const _hoisted_41 = { class: "kitchen-stove-info" }
const _hoisted_42 = { class: "stove-name" }
const _hoisted_43 = { class: "time-person-info" }
const _hoisted_44 = { class: "actions" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = { class: "empty-state" }
const _hoisted_47 = { class: "loading-state" }

import { ref, computed, reactive, onMounted, watch } from 'vue';
  import { useRouter } from 'vue-router';
  import { fetchTableList, fetchStoveList } from '@/service/base';
  import { getOrderOutSelectList, printFood } from '@/service/order';
  import type { OrderOutSelectListModel } from '@/model/order';
  import { export_json_to_excel } from '@/utils/Export2Excel';

  import { useRestaurantKitchen } from '@/composables/useRestaurantKitchen';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ServingHistoryView',
  setup(__props) {

  const router = useRouter();

  const goBack = () => {
    router.back();
  };

  // 数据状态
  const loading = ref(false);
  const {
    shops: shopList,
    currentShop,
    kitchens,
    currentKitchen,
    selectionVersion,
    selectionLoading,
    selectionMessage,
    loadShops,
  } = useRestaurantKitchen();
  const kitchenList = computed(() =>
    kitchens.value.map((item) => ({ kitchenId: item.id, kitchenName: item.name })),
  );
  const tableList = ref<any[]>([]);
  const stoveList = ref<any[]>([]);
  const historyList = ref<OrderOutSelectListModel[]>([]);
  const totalQuantity = computed(() =>
    historyList.value.reduce((total, item) => total + Number(item.quantity || 0), 0),
  );

  // 筛选条件
  const filters = reactive({
    startDate: '', // 下单开始日期
    endDate: '', // 下单结束日期
    shopId: '', // 餐厅ID
    tableId: '', // 桌号ID
    kitchenId: '', // 厨房ID
    stoveId: '', // 灶台ID
    dishName: '', // 菜品名称
    orderNo: '', // 订单号
    status: '', // 状态：空值为全部、2待出餐、8已出餐
    onlyUnprinted: false, // 是否仅查询未打印
  });

  // 计算属性 - 可用桌号列表（根据选择的餐厅筛选）
  const availableTables = computed(() => {
    if (!filters.shopId) {
      return [];
    }
    return tableList.value.filter((table) => table.shopId === Number(filters.shopId));
  });

  // 计算属性 - 可用灶台列表（根据选择的厨房筛选）
  const availableStoves = computed(() => {
    if (!filters.kitchenId) {
      return [];
    }
    return stoveList.value.filter((stove) => stove.kitchenId === Number(filters.kitchenId));
  });

  // 计算属性 - 是否有筛选条件
  const hasFilters = computed(() => {
    return (
      filters.startDate ||
      filters.endDate ||
      filters.shopId ||
      filters.tableId ||
      filters.kitchenId ||
      filters.stoveId ||
      filters.dishName ||
      filters.orderNo ||
      filters.status ||
      filters.onlyUnprinted
    );
  });

  // 餐厅变化处理
  const onShopChange = () => {
    currentShop.value = String(filters.shopId);
  };
  const onKitchenChange = async () => {
    selectionVersion.value++;
    filters.stoveId = '';
    stoveList.value = [];
    if (filters.kitchenId) await loadStoveList(Number(filters.kitchenId));
  };
  watch(
    currentShop,
    (value) => {
      filters.shopId = value;
      filters.tableId = '';
      filters.kitchenId = '';
      filters.stoveId = '';
      tableList.value = [];
      stoveList.value = [];
      historyList.value = [];
      if (value) void loadTableList(Number(value));
    },
    { flush: 'sync' },
  );
  watch(
    selectionVersion,
    () => {
      historyList.value = [];
      loading.value = false;
    },
    { flush: 'sync' },
  );
  watch(currentKitchen, (value) => {
    if (value) void loadHistoryList();
  });

  // 加载桌号列表
  let tableRequest = 0;
  const loadTableList = async (shopId?: number) => {
    if (!shopId) return;
    const shop = currentShop.value;
    const request = ++tableRequest;
    try {
      const params: any = {
        pageNum: 1,
        pageSize: 999,
        data: {},
      };

      if (shopId) {
        params.data.shopId = shopId;
      }

      const response = await fetchTableList(params);

      if (shop !== currentShop.value || request !== tableRequest) return;
      if (response.code !== 200) throw new Error(response.msg || '加载失败');
      if (response.code === 200 && response.result && response.result.list) {
        tableList.value = response.result.list;
      }
    } catch (error) {
      if (shop !== currentShop.value || request !== tableRequest) return;
      showToast('加载选项失败，请重试');
      console.error('加载桌号列表失败:', error);
    }
  };

  // 加载灶台列表
  let stoveRequest = 0;
  const loadStoveList = async (kitchenId?: number) => {
    if (!kitchenId) return;
    const shop = currentShop.value;
    const request = ++stoveRequest;
    try {
      const params: any = {
        pageNum: 1,
        pageSize: 999,
        data: {},
      };

      if (kitchenId) {
        params.data.kitchenId = kitchenId;
      }

      const response = await fetchStoveList(params);

      if (
        shop !== currentShop.value ||
        request !== stoveRequest ||
        String(kitchenId) !== String(filters.kitchenId)
      )
        return;
      if (response.code !== 200) throw new Error(response.msg || '加载失败');
      if (response.code === 200 && response.result && response.result.list) {
        stoveList.value = response.result.list;
      }
    } catch (error) {
      if (
        shop !== currentShop.value ||
        request !== stoveRequest ||
        String(kitchenId) !== String(filters.kitchenId)
      )
        return;
      showToast('加载选项失败，请重试');
      console.error('加载灶台列表失败:', error);
    }
  };

  // 加载出菜历史列表
  let historyRequest = 0;
  const loadHistoryList = async () => {
    if (!currentShop.value || !currentKitchen.value || !kitchens.value.length) return;
    const version = selectionVersion.value;
    const request = ++historyRequest;
    try {
      loading.value = true;

      const params: any = {
        pageNum: 1,
        pageSize: 999,
        data: {},
      };

      // 构建状态筛选条件
      if (filters.status) {
        params.data.statuss = [Number(filters.status)];
      }

      // 构建其他筛选条件
      if (filters.startDate) {
        params.createtimeBegin = filters.startDate + ' 00:00:00';
      }
      if (filters.endDate) {
        params.createtimeEnd = filters.endDate + ' 23:59:59';
      }
      if (filters.shopId) {
        params.data.shopId = Number(filters.shopId);
      }
      if (filters.tableId) {
        params.data.tableId = Number(filters.tableId);
      }
      if (filters.kitchenId) {
        params.data.kitchenId = Number(filters.kitchenId);
      }
      if (filters.stoveId) {
        params.data.stoveId = Number(filters.stoveId);
      }
      if (filters.dishName) {
        params.data.shopFoodName = filters.dishName;
      }
      if (filters.orderNo && String(filters.orderNo).trim()) {
        params.data.orderNo = String(filters.orderNo).trim();
      }
      if (filters.onlyUnprinted) {
        params.data.isPrint = 0;
      }

      const response = await getOrderOutSelectList(params);
      if (version !== selectionVersion.value || request !== historyRequest) return;

      if (response.code !== 200) throw new Error(response.msg || '加载历史失败');
      if (response.code === 200 && response.result) {
        // 处理分页结果，按照其他API的模式
        if (Array.isArray(response.result)) {
          // 如果直接是数组
          historyList.value = response.result;
        } else if (
          response.result &&
          typeof response.result === 'object' &&
          'list' in response.result
        ) {
          // 如果是分页对象，有list字段
          historyList.value = (response.result as any).list || [];
        } else {
          // 如果是单个对象，包装成数组
          historyList.value = [response.result as OrderOutSelectListModel];
        }
      } else {
        historyList.value = [];
      }
      historyList.value = historyList.value.filter(
        (item) =>
          Number(item.shopId) === Number(currentShop.value) &&
          kitchens.value.some((kitchen) => Number(kitchen.id) === Number(item.kitchenId)),
      );
    } catch (error) {
      if (version !== selectionVersion.value || request !== historyRequest) return;
      showToast('加载出菜历史失败，请重试');
      console.error('加载出菜历史失败:', error);
      historyList.value = [];
    } finally {
      if (version === selectionVersion.value && request === historyRequest) loading.value = false;
    }
  };

  // 菜品类型映射
  const getDishTypeName = (foodType: number) => {
    switch (foodType) {
      case 1:
        return '热菜';
      case 2:
        return '冷菜';
      case 3:
        return '汤类';
      case 4:
        return '点心';
      case 5:
        return '饮品';
      default:
        return '';
    }
  };

  const getDishTypeClass = (foodType: number) => {
    switch (foodType) {
      case 1:
        return 'hot';
      case 2:
        return 'cold';
      case 3:
        return 'soup';
      case 4:
        return 'dim-sum';
      case 5:
        return 'drink';
      default:
        return '';
    }
  };

  // 工具函数
  const formatDate = (dateStr: string | Date) => {
    if (!dateStr) return '-';
    const d = new Date(dateStr);
    return d.toLocaleDateString();
  };

  const formatTime = (dateStr: string | Date) => {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    return d.toLocaleTimeString();
  };

  const formatDateTime = (dateStr: string | Date) => {
    if (!dateStr) return '-';
    const d = new Date(dateStr);
    return d.toLocaleString();
  };

  const getTimeSpent = (item: OrderOutSelectListModel) => {
    if (!item.startTime || !item.completeTime) return 0;
    const start = new Date(item.startTime);
    const complete = new Date(item.completeTime);
    return Math.floor((complete.getTime() - start.getTime()) / 60000);
  };

  // 获取状态样式类
  const getStatusClass = (status: number | undefined) => {
    switch (status) {
      case 2:
        return 'status-pending';
      case 8:
        return 'status-completed';
      default:
        return '';
    }
  };

  // 补打小票功能
  const showReceipt = async (item: OrderOutSelectListModel) => {
    if (!item.orderOutId) {
      showToast('订单信息不完整，无法补打小票');
      return;
    }

    try {
      const response = await printFood({ orderOutId: item.orderOutId });
      if (response.code === 200) {
        showToast('补打小票成功');
      } else {
        showToast(response.msg || '补打小票失败');
      }
    } catch (error) {
      console.error('补打小票失败:', error);
      showToast('补打小票失败，请稍后重试');
    }
  };

  const showToast = (message: string) => {
    // 创建提示框
    const toast = document.createElement('div');
    toast.className = 'toast-message';
    toast.textContent = message;
    toast.style.cssText = `
      position: fixed;
      top: 80px;
      left: 50%;
      transform: translateX(-50%);
      background: rgba(0, 0, 0, 0.8);
      color: white;
      padding: 12px 24px;
      border-radius: 8px;
      z-index: 1000;
      font-size: 16px;
      font-weight: 500;
    `;

    document.body.appendChild(toast);

    setTimeout(() => {
      if (document.body.contains(toast)) {
        document.body.removeChild(toast);
      }
    }, 2000);
  };

  // Excel导出功能
  const exportToExcel = () => {
    try {
      // 准备导出数据
      const exportData = historyList.value.map((item, index) => [
        index + 1, // 序号
        item.foodName || '', // 菜品名称 // 菜品类型
        `${item.shopName}【${item.tableName}】`, // 桌号信息
        item.orderNo || '', // 订单号
        formatDateTime(item.createTime), // 下单时间
        formatDateTime(item.completeTime), // 出菜时间
        `${item.quantity}份`, // 菜品数量
        `${item.kitchenName || ''} - ${item.stoveName || ''}`, // 制作厨房/灶台
        item.statusName || '未知', // 状态
        `${getTimeSpent(item)}分钟`, // 用时
        item.createBy || '', // 服务人员
      ]);

      // 表头
      const header = [
        '序号',
        '菜品名称',
        '桌号信息',
        '订单号',
        '下单时间',
        '出菜时间',
        '菜品数量',
        '制作厨房/灶台',
        '状态',
        '用时',
        '服务人员',
      ];

      // 生成文件名
      const now = new Date();
      const dateStr = now.toISOString().split('T')[0];
      const timeStr = now.toTimeString().split(' ')[0].replace(/:/g, '-');
      const filename = `出菜历史记录_${dateStr}_${timeStr}`;

      // 使用Excel导出工具
      export_json_to_excel({
        header,
        data: exportData,
        filename,
        autoWidth: true,
        bookType: 'xlsx',
      });

      console.log('Excel导出成功');
    } catch (error) {
      console.error('Excel导出失败:', error);
      alert('导出失败，请重试');
    }
  };

  // 生命周期
  onMounted(async () => {
    // 设置默认日期为今天
    filters.startDate = new Date().toISOString().split('T')[0];
    filters.endDate = new Date().toISOString().split('T')[0];

    // 加载基础数据
    await loadShops();
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(selectionMessage))
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_unref(selectionMessage)), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", { class: "history-header" }, [
        _createElementVNode("div", { class: "history-header-left" }, [
          _createElementVNode("button", {
            class: "history-back-btn",
            onClick: goBack
          }, _cache[10] || (_cache[10] = [
            _createElementVNode("i", { class: "fas fa-arrow-left" }, null, -1)
          ])),
          _cache[11] || (_cache[11] = _createElementVNode("h1", { class: "history-header-title" }, "出菜历史", -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _cache[12] || (_cache[12] = _createElementVNode("label", { class: "filter-label" }, "下单开始日期", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.startDate) = $event)),
            type: "date",
            class: "filter-input"
          }, null, 512), [
            [_vModelText, filters.startDate]
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[13] || (_cache[13] = _createElementVNode("label", { class: "filter-label" }, "下单结束日期", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.endDate) = $event)),
            type: "date",
            class: "filter-input"
          }, null, 512), [
            [_vModelText, filters.endDate]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[15] || (_cache[15] = _createElementVNode("label", { class: "filter-label" }, "餐厅筛选", -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.shopId) = $event)),
            class: "filter-input",
            disabled: "",
            onChange: onShopChange
          }, [
            _cache[14] || (_cache[14] = _createElementVNode("option", {
              value: "",
              disabled: ""
            }, "请选择餐厅", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(shopList), (shop) => {
              return (_openBlock(), _createElementBlock("option", {
                key: shop.shopId,
                value: String(shop.shopId)
              }, _toDisplayString(shop.shopName), 9, _hoisted_8))
            }), 128))
          ], 544), [
            [_vModelSelect, filters.shopId]
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _cache[17] || (_cache[17] = _createElementVNode("label", { class: "filter-label" }, "桌号筛选", -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.tableId) = $event)),
            class: "filter-input",
            disabled: !filters.shopId
          }, [
            _cache[16] || (_cache[16] = _createElementVNode("option", { value: "" }, "全部桌号", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableTables.value, (table) => {
              return (_openBlock(), _createElementBlock("option", {
                key: table.tableId,
                value: table.tableId
              }, _toDisplayString(table.tableName), 9, _hoisted_11))
            }), 128))
          ], 8, _hoisted_10), [
            [_vModelSelect, filters.tableId]
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _cache[19] || (_cache[19] = _createElementVNode("label", { class: "filter-label" }, "厨房筛选", -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filters.kitchenId) = $event)),
            class: "filter-input",
            disabled: _unref(selectionLoading) || !_unref(kitchens).length,
            onChange: onKitchenChange
          }, [
            _cache[18] || (_cache[18] = _createElementVNode("option", { value: "" }, "全部厨房", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(kitchenList.value, (kitchen) => {
              return (_openBlock(), _createElementBlock("option", {
                key: kitchen.kitchenId,
                value: kitchen.kitchenId
              }, _toDisplayString(kitchen.kitchenName), 9, _hoisted_14))
            }), 128))
          ], 40, _hoisted_13), [
            [_vModelSelect, filters.kitchenId]
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _cache[21] || (_cache[21] = _createElementVNode("label", { class: "filter-label" }, "灶台筛选", -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filters.stoveId) = $event)),
            class: "filter-input",
            disabled: !filters.kitchenId
          }, [
            _cache[20] || (_cache[20] = _createElementVNode("option", { value: "" }, "全部灶台", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableStoves.value, (stove) => {
              return (_openBlock(), _createElementBlock("option", {
                key: stove.stoveId,
                value: stove.stoveId
              }, _toDisplayString(stove.stoveName), 9, _hoisted_17))
            }), 128))
          ], 8, _hoisted_16), [
            [_vModelSelect, filters.stoveId]
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _cache[22] || (_cache[22] = _createElementVNode("label", { class: "filter-label" }, "菜品名称", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((filters.dishName) = $event)),
            type: "text",
            class: "filter-input",
            placeholder: "输入菜品名称"
          }, null, 512), [
            [_vModelText, filters.dishName]
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _cache[23] || (_cache[23] = _createElementVNode("label", { class: "filter-label" }, "订单号", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((filters.orderNo) = $event)),
            type: "text",
            class: "filter-input",
            placeholder: "输入订单号"
          }, null, 512), [
            [_vModelText, filters.orderNo]
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _cache[25] || (_cache[25] = _createElementVNode("label", { class: "filter-label" }, "状态筛选", -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((filters.status) = $event)),
            class: "filter-input"
          }, _cache[24] || (_cache[24] = [
            _createElementVNode("option", { value: "" }, "全部", -1),
            _createElementVNode("option", { value: "2" }, "待出餐", -1),
            _createElementVNode("option", { value: "8" }, "已出餐", -1)
          ]), 512), [
            [_vModelSelect, filters.status]
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _cache[27] || (_cache[27] = _createElementVNode("label", { class: "filter-label" }, "打印筛选", -1)),
          _createElementVNode("label", _hoisted_22, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((filters.onlyUnprinted) = $event)),
              type: "checkbox",
              class: "checkbox-input"
            }, null, 512), [
              [_vModelCheckbox, filters.onlyUnprinted]
            ]),
            _cache[26] || (_cache[26] = _createTextVNode(" 仅未打印 ", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _cache[29] || (_cache[29] = _createElementVNode("label", { class: "filter-label" }, " ", -1)),
          _createElementVNode("button", {
            class: "filter-btn",
            disabled: loading.value,
            onClick: loadHistoryList
          }, [
            _cache[28] || (_cache[28] = _createElementVNode("i", { class: "fas fa-search" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(loading.value ? '筛选中...' : '筛选'), 1)
          ], 8, _hoisted_24)
        ]),
        _createElementVNode("div", _hoisted_25, [
          _cache[31] || (_cache[31] = _createElementVNode("label", { class: "filter-label" }, " ", -1)),
          _createElementVNode("button", {
            class: "export-btn",
            disabled: loading.value || historyList.value.length === 0,
            onClick: exportToExcel
          }, _cache[30] || (_cache[30] = [
            _createElementVNode("i", { class: "fas fa-file-excel" }, null, -1),
            _createTextVNode(" 导出Excel ", -1)
          ]), 8, _hoisted_26)
        ])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _cache[32] || (_cache[32] = _createTextVNode(" 出菜历史记录 - 共 ", -1)),
          _createElementVNode("span", null, _toDisplayString(historyList.value.length), 1),
          _cache[33] || (_cache[33] = _createTextVNode(" 条记录，菜品总份数 ", -1)),
          _createElementVNode("span", null, _toDisplayString(totalQuantity.value), 1),
          _cache[34] || (_cache[34] = _createTextVNode(" 份 ", -1))
        ]),
        _cache[39] || (_cache[39] = _createStaticVNode("<div class=\"history-columns\" data-v-f1f51238><div class=\"item-info item-columns\" data-v-f1f51238><div data-v-f1f51238>菜品名称</div><div data-v-f1f51238>桌号信息</div><div data-v-f1f51238>订单号</div><div data-v-f1f51238>下单时间</div><div data-v-f1f51238>出菜时间</div><div data-v-f1f51238>数量</div><div data-v-f1f51238>厨房/灶台</div><div data-v-f1f51238>状态</div><div data-v-f1f51238>打印状态</div><div data-v-f1f51238>用时/人员</div></div><div class=\"actions actions-column\" data-v-f1f51238>操作</div></div>", 1)),
        _createElementVNode("div", _hoisted_29, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(historyList.value, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.orderOutId,
              class: "history-item"
            }, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, _toDisplayString(item.foodName), 1),
                  _createElementVNode("div", _hoisted_33, [
                    (getDishTypeName(item.foodType))
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: _normalizeClass(["dish-type", getDishTypeClass(item.foodType)])
                        }, _toDisplayString(getDishTypeName(item.foodType)), 3))
                      : _createCommentVNode("", true),
                    (item.foodSpecName && item.foodSpecName !== '标准')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(item.foodSpecName), 1))
                      : _createCommentVNode("", true),
                    (item.foodCookDesc && item.foodCookDesc.trim() !== '')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_35, [
                          _cache[35] || (_cache[35] = _createElementVNode("i", { class: "fas fa-utensils" }, null, -1)),
                          _createTextVNode(_toDisplayString(item.foodCookDesc), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_36, _toDisplayString(item.shopName) + "【" + _toDisplayString(item.tableName) + "】", 1),
                _createElementVNode("div", _hoisted_37, _toDisplayString(item.orderNo || '-'), 1),
                _createElementVNode("div", _hoisted_38, [
                  _createTextVNode(_toDisplayString(formatDate(item.createTime)), 1),
                  _cache[36] || (_cache[36] = _createElementVNode("br", null, null, -1)),
                  _createTextVNode(" " + _toDisplayString(formatTime(item.createTime)), 1)
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createTextVNode(_toDisplayString(formatDate(item.completeTime)), 1),
                  _cache[37] || (_cache[37] = _createElementVNode("br", null, null, -1)),
                  _createTextVNode(" " + _toDisplayString(formatTime(item.completeTime)), 1)
                ]),
                _createElementVNode("div", _hoisted_40, _toDisplayString(item.quantity) + "份", 1),
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("div", null, _toDisplayString(item.kitchenName), 1),
                  _createElementVNode("div", _hoisted_42, _toDisplayString(item.stoveName), 1)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["status-info", getStatusClass(item.status)])
                }, _toDisplayString(item.statusName || '未知'), 3),
                _createElementVNode("div", {
                  class: _normalizeClass(["print-status", item.isPrint === 0 ? 'print-unprinted' : 'print-printed'])
                }, _toDisplayString(item.isPrint === 0 ? '未打印' : `已打印(${item.isPrint ?? '-'})`), 3),
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("div", null, "用时" + _toDisplayString(getTimeSpent(item)) + "分钟", 1),
                  _createElementVNode("div", null, _toDisplayString(item.createBy || '-'), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("button", {
                  class: "action-btn reprint",
                  onClick: ($event: any) => (showReceipt(item))
                }, _cache[38] || (_cache[38] = [
                  _createElementVNode("i", { class: "fas fa-receipt" }, null, -1),
                  _createTextVNode(" 补打小票 ", -1)
                ]), 8, _hoisted_45)
              ])
            ]))
          }), 128))
        ])
      ], 512), [
        [_vShow, historyList.value.length > 0]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_46, [
        _cache[40] || (_cache[40] = _createElementVNode("i", { class: "fas fa-history" }, null, -1)),
        _cache[41] || (_cache[41] = _createElementVNode("h3", null, "暂无历史记录", -1)),
        _createElementVNode("p", null, _toDisplayString(hasFilters.value ? '没有符合筛选条件的记录' : '还没有任何出菜记录'), 1)
      ], 512), [
        [_vShow, historyList.value.length === 0 && !loading.value]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_47, _cache[42] || (_cache[42] = [
        _createElementVNode("i", { class: "fas fa-spinner fa-spin" }, null, -1),
        _createElementVNode("p", null, "正在加载历史记录...", -1)
      ]), 512), [
        [_vShow, loading.value]
      ])
    ])
  ]))
}
}

})